import React from "react";

import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PanoramaIcon from "@mui/icons-material/Panorama";
import Support from "@mui/icons-material/Support";
import Payments from "@mui/icons-material/Payments";
import NotesIcon from "@mui/icons-material/Notes";
import RedeemIcon from "@mui/icons-material/Redeem";
import ShowChartIcon from '@mui/icons-material/ShowChart';
import UploadIcon from "@mui/icons-material/Upload";
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import GradeIcon from '@mui/icons-material/Grade';
import DashboardLayout from "../components/common/DashboardLayout";

const mainListItemsArray = [
  {
    id: 1,
    label: "Advisory",
    link: "/advisor/advisory-form",
    icon: <Support />,
  },
  {
    id: 2,
    label: "Trades (Cash & Futures)",
    link: "/advisor/trade-calls?activeTab=cash",
    icon: <Payments />,
  },
  // {
  //   id: 7,
  //   label: "Nifty/BankNifty/FinNifty",
  //   link: "/advisor/nifty",
  //   icon: <ShowChartIcon />,
  // },
  {
    id: 3,
    label: "User Support",
    link: "/advisor/user-support",
    icon: <SupportAgentIcon />,
  },
  {
    id: 4,
    label: "Add Carousel",
    link: "/advisor/banner",
    icon: <PanoramaIcon />,
  },
  {
    id: 5,
    label: "Create Ticker",
    link: "/advisor/create-ticker",
    icon: <NotesIcon />,
  },
  // {
  //   id: 6,
  //   label: "Coupons",
  //   link: "/advisor/coupons",
  //   icon: <RedeemIcon />,
  // },
  {
    id: 6,
    label: "Upload Banners",
    link: "/advisor/upload-banners",
    icon: <UploadIcon />,
  },
  {
    id: 7,
    label: "Customer Info",
    link: "/advisor/customer-info",
    icon: <SupportAgentIcon />,
  },
   {
    id: 8,
    label: "Subscription-Visit",
    link: "/advisor/user-subscription-history",
    icon: <RecentActorsIcon/>,
  },
  {
    id:9,
    label: "User Rating",
    link: "/advisor/user-rating",
    icon: <GradeIcon/>
  }
];

export default function AdvisorDashboardLayout() {
  return <DashboardLayout mainListItems={mainListItemsArray} />;
}
